const Physician = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <div className="mx-auto h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />
                    <p className="mt-6 font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Gespräch mit dem Arzt
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Alles beginnt mit dem täglichen Gespräch: die Harmonisierung von Körper und Geist
                    </h2>
                    <div className="mt-8 space-y-6 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        <p>
                            Während Ihres Aufenthalts finden täglich ausführliche Konsultationen mit einem erfahrenen Ayurveda-Arzt statt. Dieses Gespräch bildet den wichtigsten Grundstein für ein individuelles Behandlungsprogramm und die tägliche Ayurveda-Ernährung, die genau zu Ihrem Zustand passt.
                        </p>
                        <p>
                            Der Arzt begleitet Sie mit Aufmerksamkeit und Sorgfalt, beobachtet Veränderungen Ihrer Gesundheit und den Verlauf Ihrer Erholung und bleibt Ihnen dabei stets zur Seite. Eine echte Ayurveda-Behandlung stärkt die natürliche Immunität, bringt den Körper wieder in Fluss und unterstützt die innere Energie auf sanfte Weise. Wenn Körper und Geist in Harmonie stehen, erleben Sie tiefe Ruhe, Klarheit und ein angenehmes Gefühl von innerem Gleichgewicht.
                        </p>
                    </div>
                    <div className="mx-auto mt-8 h-px w-32 bg-amber-200" />
                </div>
            </div>
        </section>;
};
export default Physician;
